import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { LoaDialog } from 'TAP/components/loaDialog';
import { RedTheme } from 'common/global';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { TapGlobalMessages } from 'TAP/global';
import { TrainingPlanViewIndividualUser } from 'TAP/pages/trainingPlanViewIndividualUser';
import { TrainingPlanViewManagerSingleTeam } from 'TAP/pages/trainingPlanViewManagerSingleTeam';
import { formatTime, getGAMeasurementId } from 'TAP/utils/commonMethods';
import { useSelector } from 'react-redux';
import { NUMBER_ARRAY, DASHBOARD_DATA_ACCEPTABLE_STATUSES } from 'common/global/constants';
import { userRole as userRoleData } from 'TAP/styles/genericStyles/userRole';
import ReactGA from 'react-ga4';
import { useScreen } from 'common/hooks/useScreen';
import { TransferUniversalDashboardData } from 'TAP/redux/actions';
import { useDispatch } from 'react-redux';
import { getUserAgentBrowser, getUserAgentOS } from 'TAP/utils/commonMethods';

export const TrainingView = () => {
  const [pageHeading, setPageHeading] = useState('');
  const [userRole, setUserRole] = useState(0);
  const [selectedTabValue, setSelectedTabValue] = useState(0);
  const [pageTabs, setPageTabs] = useState([]);
  const [lastRefreshDate, setLastRefreshDate] = useState('');
  const [leaveDialogStatus, setLeaveDialogStatus] = useState(false);
  const screen = useScreen();
  let params = {};
  let redtheme = RedTheme;
  let getLoggedInUserDetails = useSelector((state) => state.tapUserDetailsRd);
  const dispatch = useDispatch();
  const logInUserDetails = JSON.parse(localStorage.getItem('userDetails'));
  const universalDashboardData = useSelector((state) => state?.universalDashboardReducer);
  const [pageVisitedDashboardEventRegistered, setPageVisitedDashboardEventRegistered] =
    useState(false);
  useEffect(() => {
    if (
      pageVisitedDashboardEventRegistered &&
      DASHBOARD_DATA_ACCEPTABLE_STATUSES.includes(
        universalDashboardData?.isUniversalDashboardDataTransfered,
      )
    ) {
      setPageVisitedDashboardEventRegistered(false);
      localStorage.setItem(
        'userDetails',
        JSON.stringify({
          ...JSON.parse(localStorage.getItem('userDetails')),
          pageTitle: universalDashboardData?.apiResponse?.data?.data?.pageTitle,
          pageSubTitle: universalDashboardData?.apiResponse?.data?.data?.pageSubtitle,
          visitStartTime: universalDashboardData?.apiResponse?.data?.data?.visitStartTime,
          visitEndTime: null,
          id: universalDashboardData?.apiResponse?.data?.data?.id,
          reActivityEvent: DASHBOARD_DATA_ACCEPTABLE_STATUSES[NUMBER_ARRAY.zero],
        }),
      );
    }
  }, [pageVisitedDashboardEventRegistered, universalDashboardData]);

  useEffect(() => {
    ReactGA.initialize(`G-${getGAMeasurementId()}`);
    ReactGA.send({ hitType: 'pageview', page: '/TAP/trainingview', title: 'Training Plan View' });
  }, []);

  useEffect(() => {
    if (getLoggedInUserDetails && Object.keys(getLoggedInUserDetails).length) {
      setUserRole(parseInt(getLoggedInUserDetails?.userDetails?.data[0].user_role));
      let leaveIndicator = getLoggedInUserDetails?.userDetails?.data[0].leave_of_absence;

      if (leaveIndicator.trim() === 'N') {
        setLeaveDialogStatus(false);
      } else {
        setLeaveDialogStatus(true);
        setSelectedTabValue(1);
      }

      const formattedLastRefreshTime = formatTime(
        getLoggedInUserDetails?.userDetails?.data[0].last_refresh_date,
      );
      setLastRefreshDate(formattedLastRefreshTime);
    }
  }, [getLoggedInUserDetails]);

  useEffect(() => {
    if (
      logInUserDetails?.user_email &&
      logInUserDetails?.idSession &&
      userRole &&
      ((userRole !== NUMBER_ARRAY.one && pageTabs.length > NUMBER_ARRAY.zero) ||
        userRole === NUMBER_ARRAY.one)
    ) {
      triggerTransferUniversalDashboardData();
    }
  }, [logInUserDetails?.user_email, logInUserDetails?.idSession, userRole, pageTabs]);

  useEffect(() => {
    setPageHeading('Training Plan View');

    if (userRole === NUMBER_ARRAY.two) {
      setPageTabs([{ name: 'My Plan' }, { name: 'My Team' }]);
    }
    if (userRole === NUMBER_ARRAY.three) {
      setPageTabs([{ name: 'My Plan' }, { name: 'My Direct Reports' }]);
    }
  }, [userRole]);

  useEffect(() => {
    const onBeforeUnload = () => {
      const currLogInUserDetails = JSON.parse(localStorage.getItem('userDetails'));
      dispatch(
        TransferUniversalDashboardData({
          apiType: 'page_exit',
          apiSubType: '',
          userEmailId: currLogInUserDetails?.user_email ?? null,
          pageTitle: currLogInUserDetails?.pageTitle ?? null,
          pageSubTitle: currLogInUserDetails?.pageSubTitle ?? null,
          pageURL: window.location.href,
          appName: process.env.REACT_APP_NAME,
          targetUrl: 'pagevisit/entry',
          idSession: currLogInUserDetails?.idSession ?? null,
          browser: getUserAgentBrowser(),
          os: getUserAgentOS(),
          visitStartTime: currLogInUserDetails?.visitStartTime ?? null,
          visitEndTime: new Date().toISOString('en-US', { timeZone: 'UTC' }),
          id: currLogInUserDetails?.id ?? null,
        }),
      );
    };

    window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, []);

  const triggerTransferUniversalDashboardData = (tabValue = NUMBER_ARRAY.zero) => {
    const currLogInUserDetails = JSON.parse(localStorage.getItem('userDetails'));
    if (
      currLogInUserDetails?.id &&
      currLogInUserDetails?.visitStartTime &&
      currLogInUserDetails?.pageTitle
    ) {
      dispatch(
        TransferUniversalDashboardData({
          apiType: 'page_exit',
          apiSubType: '',
          userEmailId: currLogInUserDetails?.user_email ?? null,
          pageTitle: currLogInUserDetails?.pageTitle ?? null,
          pageSubTitle: currLogInUserDetails?.pageSubTitle ?? null,
          pageURL: window.location.href,
          appName: process.env.REACT_APP_NAME,
          targetUrl: 'pagevisit/entry',
          idSession: currLogInUserDetails?.idSession ?? null,
          browser: getUserAgentBrowser(),
          os: getUserAgentOS(),
          visitStartTime: currLogInUserDetails?.visitStartTime ?? null,
          visitEndTime: new Date().toISOString('en-US', { timeZone: 'UTC' }),
          id: currLogInUserDetails?.id ?? null,
        }),
      );
    }
    setPageVisitedDashboardEventRegistered(true);
    dispatch(
      TransferUniversalDashboardData({
        apiType: 'page_visit',
        apiSubType: '',
        userEmailId: currLogInUserDetails?.user_email,
        pageTitle: 'Training Plan View',
        pageSubTitle: pageTabs[tabValue]?.name ?? '',
        pageURL: window.location.href,
        appName: process.env.REACT_APP_NAME,
        targetUrl: 'pagevisit/entry',
        ipAddress: null,
        idSession: currLogInUserDetails?.idSession ?? null,
        browser: getUserAgentBrowser(),
        os: getUserAgentOS(),
        visitStartTime: new Date().toISOString('en-US', { timeZone: 'UTC' }),
        visitEndTime: null,
        id: null,
      }),
    );
  };

  const handleChange = (_event, newValue) => {
    setSelectedTabValue(newValue);
    triggerTransferUniversalDashboardData(newValue);
  };

  const handleCloseLoaDialog = () => {
    setLeaveDialogStatus(false);
    setSelectedTabValue(1);
    if (selectedTabValue === 0) {
      setLeaveDialogStatus(true);
    }
  };

  const handleOpenAskGSLink = () => {
    window.open(TapGlobalMessages.URLS.ASK_GS, '_blank');
  };

  const renderLAODialog = (userRoleValue) => {
    params = {
      isOpen: true,
      isRightButtonVisible: true,
      rightButtonText: `AskGS`,
      dialogTitle: `Sorry!`,
      onRightButtonClick: handleOpenAskGSLink,
    };
    params = {
      ...params,
      onClose: userRoleValue == '3' ? null : handleCloseLoaDialog,
      leftButtonText: userRoleValue == '1' ? `View My Team's Data` : null,
      isLeftButtonVisible: userRoleValue == '1' ? true : null,
      onLeftButtonClick: userRoleValue == '1' ? handleCloseLoaDialog : null,
      isCloseIconVisible: userRoleValue == '2' ? true : null,
      dialogBodyMessage1:
        userRoleValue == '3'
          ? TapGlobalMessages.LOA.LOA_NO_DATA
          : TapGlobalMessages.LOA.LOA_NO_DATA_MANAGER,
      dialogBodyMessage2:
        userRoleValue == '3'
          ? TapGlobalMessages.LOA.ASK_GS_HELPER
          : TapGlobalMessages.LOA.ASK_GS_HELPER_MANAGER,
    };

    return <LoaDialog {...params} />;
  };

  return (
    <>
      <Box
        sx={{
          width: screen.isMobile || screen.isTablet ? 'auto' : '100%',
          mb: '27px',
          padding: {
            xs: '0px 10px',
            sm: '0px 10px',
            md: '0px 42px',
            lg: '0px 72px',
            xl: '0px 72px',
          },
          marginLeft: '22px',
        }}
      >
        <Typography
          //gutterBottom
          variant='h3'
          component='h3'
          sx={{
            fontSize: !screen.isDesktop ? (screen.isTablet ? '31px' : '25px') : '39px',
            fontFamily: '"JohnsonDisplay-Bold"',
            lineHeight: !screen.isDesktop ? '32px' : '48px',
            fontWeight: 700,
            marginBottom: '4px',
          }}
        >
          {pageHeading}
        </Typography>
        <Typography
          data-testid='lastRefreshDate'
          //gutterBottom
          variant='div'
          component='div'
          sx={{
            fontSize: screen.isMobile ? '10px' : '14px',
            lineHeight: screen.isMobile ? '12px' : '16px',
            color: redtheme.palette.fontColor.gray,
            fontFamily: '"JohnsonText-Regular"',
            fontWeight: screen.isMobile ? 500 : 400,
            marginBottom: '9px',
          }}
        >
          Last refresh {lastRefreshDate}
        </Typography>
        <Typography
          //gutterBottom
          variant='div'
          component='div'
          sx={{
            fontFamily: '"JohnsonText-Light"',
            fontSize: screen.isMobile ? '10px' : '14px',
            fontStyle: 'normal',
            fontWeight: screen.isMobile ? 500 : 400,
            lineHeight: screen.isMobile ? '12px' : '16px',
            color: redtheme.palette.fontColor.gray,
          }}
          data-testid='tpvbreifdescription'
        >
          {TapGlobalMessages.trainingPlanView.breifDescription}
        </Typography>
      </Box>

      {userRole === 1 ? (
        leaveDialogStatus === true ? (
          renderLAODialog(userRoleData.usr3)
        ) : (
          <>
            <br></br>
            <br></br>
            <TrainingPlanViewIndividualUser
              userEmailId={
                getLoggedInUserDetails?.userDetails?.data[NUMBER_ARRAY.zero]?.user_email ?? null
              }
              tabName={pageTabs[selectedTabValue]?.name}
            />
          </>
        )
      ) : (
        <>
          <Box
            sx={{
              // display: 'flex',
              marginTop: '10px',
              background: redtheme.palette.box.white,
            }}
          >
            <Box
              sx={{
                width: !screen.isDesktop ? '100%' : '52%',
                mb: '35px',
                padding: {
                  xs: '0px 10px',
                  sm: '0px 10px',
                  md: '0px 42px',
                  lg: '0px 72px',
                  xl: '0px 72px',
                },
                marginTop: '15px',
              }}
            >
              <Tabs
                data-testid='managerSingleTeamMainTabs'
                value={selectedTabValue}
                onChange={handleChange}
                TabIndicatorProps={{
                  sx: {
                    height: '3px',
                    borderRadius: '3px',
                  },
                }}
                sx={{
                  minHeight: '45px',
                  '& .Mui-selected': {
                    fontWeight: 700,
                    color: redtheme.palette.box.strong_red,
                  },
                  marginLeft: '6px',
                }}
                aria-label='TAP Navigation'
              >
                {pageTabs &&
                  pageTabs?.length !== 0 &&
                  pageTabs.map((link, index) => (
                    <Tab
                      key={index}
                      label={link.name}
                      data-testid={link.name}
                      sx={{
                        textTransform: 'none',
                        borderBottom: 3,
                        fontSize: '16px',
                        borderColor: 'divider',
                        fontWeight: '400',
                        minHeight: '45px',
                        color: `${redtheme.palette.fontColor.very_dark_grey} !important`,
                      }}
                    />
                  ))}
              </Tabs>
            </Box>
          </Box>

          {selectedTabValue === 0 ? (
            leaveDialogStatus === true ? (
              userRole === 1 ? (
                renderLAODialog(userRoleData.usr2)
              ) : (
                renderLAODialog(userRoleData.usr1)
              )
            ) : (
              <TrainingPlanViewIndividualUser
                userEmailId={
                  getLoggedInUserDetails?.userDetails?.data[NUMBER_ARRAY.zero]?.user_email ?? null
                }
                tabName={pageTabs[selectedTabValue]?.name}
              />
            )
          ) : (
            <TrainingPlanViewManagerSingleTeam
              userEmailId={
                getLoggedInUserDetails?.userDetails?.data[NUMBER_ARRAY.zero]?.user_email ?? null
              }
              tabName={pageTabs[selectedTabValue]?.name}
            />
          )}
        </>
      )}
    </>
  );
};
